import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import esTranslation from "./locales/es.json";

export type Section = {
  title: string;
  subtitle?: string;
  description?: string;
  link: string;
  values?: string[];
};

const resources = {
  es: {
    translation: esTranslation
  },
};

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: "es",
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
